import React, { useEffect } from "react";
import anime from "animejs";
import styled from "styled-components";
import { settingState, unlockState } from "@stores/modal";
import { bookmarkStore, bgmState, appData } from "@stores/bookdata";
import { appType } from "@/data/data";
import { useAtom, useAtomValue, useSetAtom } from "jotai";
import useModal from "@hooks/useModal";

const Wrap = styled.div`
  position: fixed;
  width: 1920px;
  height: 1200px;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;

  &.external {
    .password-box-wrap {
      height: 470px;
      .simg.reset {
        display: none;
      }
      .button-wrap {
        height: 410px;
      }
      .version-wrap {
        bottom: 15px;
        left: 548px;
      }
    }
  }
`;

const Box = styled.div`
  position: relative;
  opacity: 0;
  width: 972px;
  height: 620px;
  border-radius: 90px;
  background-color: #ff665f;
`;

const SettingImage = styled.img`
  position: absolute;
  left: 105px;
  top: 60px;
  width: 326px;
  height: 349px;
`;

const InputWrap = styled.div`
  position: absolute;
  right: 30px;
  top: 20px;
  width: 470px;
  height: 580px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`;

const CloseButton = styled.button`
  position: absolute;
  left: 0;
  top: 100px;
  color: #fff;
  font-size: 40px;
  width: 145px;
  height: 123px;
  background: url(${require("@assets/img/icon_popup_back.png")}) no-repeat;
  background-size: 100% 100%;
`;

const SWrap = styled.div`
  width: 459px;
  height: 171px;
  position: relative;
  &.bgm-off {
    background: url(${require("@assets/img/setting_bgm_off.png")});
    background-size: 100% 100%;
    > button {
      position: absolute;
      left: 30px;
      top: 83px;
      width: 400px;
      height: 67px;
    }
  }
  &.bgm-on {
    background: url(${require("@assets/img/setting_bgm_on.png")});
    background-size: 100% 100%;
    > button {
      position: absolute;
      left: 30px;
      top: 83px;
      width: 400px;
      height: 67px;
    }
  }
  &.bookmark {
    background: url(${require("@assets/img/setting_bookmark.png")});
    > button {
      position: absolute;
      left: 30px;
      top: 83px;
      width: 400px;
      height: 67px;
    }
  }
  &.bookmark-off {
    background: url(${require("@assets/img/setting_bookmark_off.png")});
    > button {
      pointer-events: none;
      position: absolute;
      left: 30px;
      top: 83px;
      width: 400px;
      height: 67px;
    }
  }
  &.reset {
    background: url(${require("@assets/img/setting_reset.png")});
    > button {
      position: absolute;
      left: 30px;
      top: 83px;
      width: 400px;
      height: 67px;
    }
  }
`;

const Version = styled.div`
  font-size: 20px;
  color: #85332f;
  position: absolute;
  left: 100px;
  bottom: 120px;
  width: 330px;
  text-align: center;
  font-family: sans-serif;
`;

const Settings = () => {
  const data = useAtomValue(appData);
  const setSettingPop = useSetAtom(settingState);
  const setUnlocklPop = useSetAtom(unlockState);
  const [bookmarkData, setBookMark] = useAtom(bookmarkStore);
  const [isBgm, setBgm] = useAtom(bgmState);

  const { showAlert } = useModal();

  const onClose = () => {
    setSettingPop({
      show: false,
    });
  };

  /*
    setUnLock({
      show: true,
      data: bookData,
    });
*/

  useEffect(() => {
    anime({
      targets: ".password-box-wrap",
      opacity: [0, 1],
      scale: [0.6, 1],
      easing: "easeOutBack",
      duration: 500,
    });
  }, []);

  return (
    <Wrap className={appType === "external" ? "external" : ""}>
      <Box className="password-box-wrap">
        <Version className="version-wrap">{`Build version ${data.appVer}`}</Version>
        <CloseButton type="button" onClick={onClose} />
        <SettingImage src={require("@assets/img/setting_img.png")} alt="" />
        <InputWrap className="button-wrap">
          <SWrap className={isBgm === 0 ? "bgm-on" : "bgm-off"}>
            <button
              tyle="button"
              onClick={() => {
                if (isBgm > 0) {
                  setBgm(0);
                  window.__bgmVolume = 0;
                } else {
                  setBgm(0.5);
                  window.__bgmVolume = 0.5;
                }
                if (window.__bgmSound) {
                  window.__bgmSound.volume(window.__bgmVolume);
                }
              }}
            />
          </SWrap>
          <SWrap
            className={bookmarkData.length === 0 ? "bookmark-off" : "bookmark"}
          >
            <button
              tyle="button"
              onClick={() => {
                showAlert(
                  `<div style="font-size: 50px; margin-top: 35px;">모든 즐겨찾기를 삭제하시겠습니까?</div>`,
                  "confirm"
                ).then((value) => {
                  if (value === true) {
                    setBookMark([]);
                  }
                });
              }}
            />
          </SWrap>

          <SWrap className="simg reset">
            <button
              tyle="button"
              onClick={() => {
                setSettingPop({
                  show: false,
                });
                setUnlocklPop({
                  show: true,
                  data: "resetMode",
                });
              }}
            />
          </SWrap>
        </InputWrap>
      </Box>
    </Wrap>
  );
};

export default Settings;
